export const ROLES = [
  {
    name: "Admin",
    value: "admin",
    description: "Add and remove recipes, members.",
  },
  {
    name: "Contributor",
    value: "contributor",
    description: "Add and remove recipes and view all members.",
  },
  {
    name: "Viewer",
    value: "viewer",
    description: "View all team recipes and members.",
  },
]
